export default "__VITE_ASSET__DUHcT6nA__"